import classnames from 'classnames';
import React from 'react';

interface Props {
  title?: string;
  children: React.ReactNode;
}

export const FilterPane = ({ children, title, ...other }: Props) => (
  <div className={classnames({ 'p-4': title })} {...other}>
    {title ? (
      <h3 className="mb-2 text-sm font-semibold uppercase tracking-wider">
        {title}
      </h3>
    ) : null}
    {children}
  </div>
);
